import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { LINKS } from '@/Module/Core/Constant';
import type { IMenuMobileItem } from '@/Module/DefaultLayout/Model';
import { prepareGradeUrlMenu } from '@/Module/Grade/Helper/prepareGradeUrlMenu';
import { IconAngleLeft } from '@/Module/Icon';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
enum SectionTypes {
  NONE,
  HOME,
  LEARNING,
  BLOG,
  CONTACT,
  LIVE,
  SUBSCRIPTION,
}
const DefaultLayoutHeaderMenu: FC = () => {
  const router = useRouter();
  const isLoggedIn = useLoggedIn();
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.Level.Levels);
  const items: IMenuMobileItem[] = useMemo(() => {
    return [{
      id: SectionTypes.HOME,
      seo_url_slug: isLoggedIn ? LINKS.LEARNING : LINKS.HOME,
      name: 'آی‌نو'
    }, {
      ...data[0]
    }, {
      ...data[1]
    }, {
      id: SectionTypes.SUBSCRIPTION,
      seo_url_slug: LINKS.SUBSCRIPTION.MAIN,
      name: 'طرح های اشتراک'
    }];
  }, [data]);
  const activeMenu = useMemo(() => {
    switch (`${router.pathname}/`) {
      case LINKS.HOME:
        return SectionTypes.HOME;
      case LINKS.BLOG:
        return SectionTypes.BLOG;
      case LINKS.GRADE:
        return SectionTypes.LEARNING;
      case LINKS.CONTACT_US:
        return SectionTypes.CONTACT;
      case LINKS.SUBSCRIPTION.MAIN:
        return SectionTypes.SUBSCRIPTION;
      case LINKS.LIVE:
        return SectionTypes.LIVE;
      default:
        return SectionTypes.NONE;
    }
  }, [router.pathname]);
  return <ul className="relative flex max-w-[600px] flex-1 flex-row items-center justify-center gap-6 lg:gap-12" data-sentry-component="DefaultLayoutHeaderMenu" data-sentry-source-file="DefaultLayoutHeaderMenu.tsx">
      {items.map(item => <li key={item.id} className={cs('group/item  h-full items-center flex justify-center')}>
          {!item.seo_url_slug ? <div className={cs('hover:ui__text-stroke-white cursor-pointer transition-all duration-300 ease-in-out', item.id === activeMenu && 'font-bold')}>
              {item.name}
            </div> : <Link className={cs('hover:ui__text-stroke-white transition-all duration-300 ease-in-out', item.id === activeMenu && 'font-bold')} href={item.seo_url_slug ?? '#'} onClick={() => dispatch(authSetIsTransitioningAction(true))}>
              {item.name}
            </Link>}
          {!!item.child?.length && <ul className="absolute inset-x-0 top-[100%] z-40 mx-auto hidden w-full flex-1 flex-row rounded-t-[16px] border-2 border-blueSix bg-white shadow-[2px_4px_0px_#000]  group-hover/item:flex">
              {item.child?.map(inner => <li key={inner.id} className={cs('flex flex-col bg-blueOne flex-1 text-center first:rounded-tr-[16px] last:rounded-tl-[16px] menuRounded')}>
                  {!inner.seo_url_slug ? <div className=" block bg-white p-4 text-sm font-bold text-blueFive transition-all duration-300  ease-in-out lg:text-base  ">
                      {inner.name}
                    </div> : <Link className=" block  bg-white p-4  text-blueFive transition-all  duration-300 ease-in-out  " href={inner.seo_url_slug ?? '#'} onClick={() => dispatch(authSetIsTransitioningAction(true))}>
                      {inner.name}
                    </Link>}
                  {!!inner.child?.length && <ul className="h-full  ">
                      {inner.child?.map(child => <li key={child.id} className={cs('group/edit relative hover:bg-white')}>
                          {child.child?.length ? <div className=" pointer-events-none   flex flex-row justify-center px-2 py-3 text-blueFive transition-all  duration-300 ease-in-out  ">
                              <div className="min-w-[80px] group-hover/edit:font-bold group-hover/edit:text-orangeFour  ">
                                {child.name}
                              </div>
                              <IconAngleLeft size="small" className="scale-75 self-end  transition-all duration-300 group-hover/edit:-translate-x-1 group-hover/edit:text-orangeFour" />
                            </div> : <Link className=" block  px-4 py-3  text-blueFive transition-all  duration-300 ease-in-out group-hover/edit:font-bold group-hover/edit:text-orangeFour " href={prepareGradeUrlMenu(child.seo_url_slug)} onClick={() => dispatch(authSetIsTransitioningAction(true))}>
                              {child.name}
                            </Link>}
                          {!!child.child?.length && <ul className="invisible absolute right-[calc(100%-30px)] top-[-2px] z-30 flex w-[150px] flex-col  overflow-hidden rounded-l-[12px] border-[2px] border-r-0 opacity-0 shadow-[0px_4px_0px_#000] transition-all duration-500 group-hover/edit:visible group-hover/edit:right-[calc(100%-0px)] group-hover/edit:top-[-2px] group-hover/edit:border-blueSix  group-hover/edit:opacity-100">
                              {child.child?.map(grade => <li key={grade.id} className={cs('bg-white py-1 ')}>
                                  <Link className=" block  bg-white px-4 py-2  text-blueFive transition-all  duration-100 ease-in-out hover:font-bold hover:text-orangeFour" href={prepareGradeUrlMenu(grade.seo_url_slug)} onClick={() => dispatch(authSetIsTransitioningAction(true))}>
                                    {grade.name}
                                  </Link>
                                </li>)}
                            </ul>}
                        </li>)}
                    </ul>}
                </li>)}
            </ul>}
        </li>)}
    </ul>;
};
export default React.memo(DefaultLayoutHeaderMenu);